module.exports = __webpack_public_path__ + "static/media/indext.82451182.jpg";